import React, {ReactNode} from 'react';
import {useTranslation} from "react-i18next";
import Typography from "@mui/material/Typography";
import {useMediaQuery} from "@mui/material";

interface IProps {
    children?: ReactNode
}

const OnlyDesktopControlSingleVoyage = ({children}:IProps) => {

    const isDesktop = useMediaQuery('(min-width:900px)');
    const {t} = useTranslation()

    if (!isDesktop) {
        return (
            <Typography>
                {t('base.notAvailableForMobile')}
            </Typography>
        )
    }
    return (
        <>
            {children}
        </>
    );
};

export default OnlyDesktopControlSingleVoyage;